/**
 * Centralized theme constants for marketer-flow.
 * Ensures consistent dark mode styling across all components.
 */

// ─── Color Scheme ──────────────────────────────────────────────────────────

export const COLORS = {
  // Lime accent — primary action color
  lime: {
    solid: '#C0FD72',
    hover: '#b0ef62',
  },
  // Text colors for dark theme
  text: {
    primary: 'text-foreground',
    secondary: 'text-gray-700',
    muted: 'text-gray-600',
    mutedHover: 'text-gray-700',
  },
  // Border colors for dark theme
  border: {
    subtle: 'border-foreground/10',
    light: 'border-foreground/15',
    lighter: 'border-foreground/20',
  },
  // Background colors for dark theme
  bg: {
    card: 'bg-card',
    cardHover: 'bg-card',
    subtle: 'bg-card',
    hover: 'bg-muted',
    hoverLight: 'bg-card',
  },
}

// ─── Button Class Presets ─────────────────────────────────────────────────

export const BUTTON_CLASSES = {
  // Primary action button — lime
  lime: 'bg-[#C0FD72] text-black hover:bg-[#b0ef62] font-semibold',

  // Secondary action button — dark outline
  darkOutline:
    'border-foreground/15 text-gray-700 hover:bg-foreground/5 hover:text-foreground bg-transparent',

  // Subtle secondary button
  darkGhost: 'text-gray-700 hover:text-foreground hover:bg-foreground/5',
}

// ─── Card Class Presets ──────────────────────────────────────────────────

export const CARD_CLASSES = {
  // Dark card background
  dark: 'bg-card border-foreground/10',
}

// ─── Dialog Class Presets ────────────────────────────────────────────────

export const DIALOG_CLASSES = {
  // Dark content background
  dark: 'bg-card border-foreground/10 text-foreground',
}

// ─── Alert/Badge Class Presets ───────────────────────────────────────────

export const ALERT_CLASSES = {
  // Dark amber/warning alert
  amberDark: 'bg-amber-500/10 border-amber-500/30',
  amberText: 'text-amber-700',
  amberTextSecondary: 'text-amber-600/80',

  // Dark green/success alert
  greenDark: 'bg-green-500/10 border-green-500/30',
  greenText: 'text-green-700',
  greenTextSecondary: 'text-green-600/80',
}
